import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {ClientesService} from "../clientes/clientes.service";
import {ClientesModel} from "../clientes/clientes.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FaturasService} from "../faturas/faturas.service";

declare var swal, $: any;

@Component({
  selector: 'app-financeiro-clientes',
  templateUrl: './financeiro-clientes.component.html'
})
export class FinanceiroClientesComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  formLaudosCdValorFixo: FormGroup;
  filtroPesquisa = {"cliente":"", "responsavel":"", "cnpj":"", "tipo_faturamento":"", "forma_pagamento":"", "periodo_faturamento":""};
  clienteFaturar: any = null;
  faturamentoValorFixoData = { data_de: '', data_ate: '', valor_fixo: '', data_fatura: '' };
  processandoFaturamentoValorFixo: boolean = false;

  clientes: ClientesModel[] = [];
  listClientes = [];
  privilegioUsuario = {"editar": false, "consultar": false};
  listFormaPagamento = [{
    "valor": "deposito",
    "texto": "Depósito"
  }/*,{
    "valor": "boleto",
    "texto": "Boleto"
  }*/];

  listTiposFaturamento = [{
    "valor": "individual",
    "texto": "Individual"
  },{
    "valor": "multiplo",
    "texto": "Multiplo"
  }];

  listPeriodoFaturamento = [{
    "valor": "diario",
    "texto": "Diário"
  },{
    "valor": "semanal",
    "texto": "Semanal"
  },{
    "valor": "quinzenal",
    "texto": "Quinzenal"
  },{
    "valor": "mensal",
    "texto": "Mensal"
  }];


  constructor(
    formBuilder: FormBuilder,
    private clientesService: ClientesService,
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.formLaudosCdValorFixo = formBuilder.group({
      data_de_fixo: [],
      data_ate_fixo: [],
      valor_fixo: [],
      data_fatura: []
    });

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'clientes'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      cliente: [],
      responsavel: [],
      cnpj: [],
      tipo_faturamento: [],
      forma_pagamento: [],
      periodo_faturamento: []
    });

    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento'])
      .subscribe(
        json => {
          this.listClientes = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });


  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.getPage(1);
  }

  delete(cliente) {
    let clientes = this.clientes;
    let clientesService = this.clientesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCliente')+cliente.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(clientes);
        }

        let index = clientes.indexOf(cliente);
        clientes.splice(index, 1);

        clientesService.apagar(cliente.id_cliente)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.clientes = clientes;
            },
            err => {
              // Revert the view back to its original state
              clientes.splice(index, 0, cliente);
              self.clientes = clientes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.cliente != ''){
      filtros['id_cliente'] = this.filtroPesquisa.cliente;
    }

    if(this.filtroPesquisa.responsavel != ''){
      filtros['responsavel'] = "**:"+this.filtroPesquisa.responsavel;
    }

    if(this.filtroPesquisa.cnpj != ''){
      filtros['cnpj'] = "**:"+this.filtroPesquisa.cnpj;
    }

    if(this.filtroPesquisa.tipo_faturamento != ''){
      filtros['faturamento_tipo'] = this.filtroPesquisa.tipo_faturamento;
    }

    if(this.filtroPesquisa.forma_pagamento != ''){
      filtros['forma_pagamento'] = this.filtroPesquisa.forma_pagamento;
    }

    if(this.filtroPesquisa.periodo_faturamento != ''){
      filtros['periodo_faturamento'] = this.filtroPesquisa.periodo_faturamento;
    }


    this.clientesService.getPaginacao(pagina, this.itensPorPagina, null, filtros, null, {'nome':'a'})
      .subscribe(data => {
          this.clientes = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  gerarFatura(id_cliente){

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaGerarFatura'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){

        self.clientesService.gerarFatura(id_cliente)
          .subscribe(res => {

            },
            err => {
              self.func.showErro(err.json());
            });

      });

  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"cliente":"", "responsavel":"", "cnpj":"", "tipo_faturamento":"", "forma_pagamento":"", "periodo_faturamento":""};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  abrirModalLaudosCdValorFixo(cliente) {
    this.clienteFaturar = cliente;
    this.faturamentoValorFixoData = { data_de: '', data_ate: '', valor_fixo: cliente.valor_laudoscd_fixo || '', data_fatura: new Date().toISOString().substr(0, 10) };
    this.formLaudosCdValorFixo.reset();
    this.formLaudosCdValorFixo.patchValue({
      data_de_fixo: '',
      data_ate_fixo: '',
      valor_fixo: cliente.valor_laudoscd_fixo || '',
      data_fatura: new Date().toISOString().substr(0, 10)
    });
    $('#data_de_fixo').val('');
    $('#data_ate_fixo').val('');
    setTimeout(() => {
      $('#data_de_fixo').val('');
      $('#data_ate_fixo').val('');
    }, 100);
    $('#modalLaudosCdValorFixo').modal('show');
  }

  limparFormLaudosCdValorFixo() {
    this.clienteFaturar = null;
    this.faturamentoValorFixoData = { data_de: '', data_ate: '', valor_fixo: '', data_fatura: '' };
    this.formLaudosCdValorFixo.reset();
    $('#data_de_fixo').val('');
    $('#data_ate_fixo').val('');
  }

  confirmarFaturamentoLaudosCdValorFixo() {
    if (!this.clienteFaturar) return;

    this.processandoFaturamentoValorFixo = true;

    this.faturasService.faturarLaudosCdValorFixo(
      this.clienteFaturar.id_cliente,
      this.faturamentoValorFixoData.data_de,
      this.faturamentoValorFixoData.data_ate,
      this.faturamentoValorFixoData.data_fatura,
      this.faturamentoValorFixoData.valor_fixo
    ).subscribe(
      json => {
        this.processandoFaturamentoValorFixo = false;
        $('#modalLaudosCdValorFixo').modal('hide');
        this.limparFormLaudosCdValorFixo();
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.operacaoRealizadaSucesso'), "success");
        this.getPage(this.paginaAtual);
      },
      error => {
        this.processandoFaturamentoValorFixo = false;
        this.func.showErro(error.json());
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/financeiro-clientes.component.ts